import React from 'react'

import Text from '../../../../../../components/pdf/Text'
import View from '../../../../../../components/pdf/View'
import { BRADESCO_RED } from '../../_helpers/brand'

/**
 * Aviso visual de "conteúdo placeholder, ainda não confirmado contra o modelo
 * aprovado". Extraído para cá porque o mesmo bloco (borda tracejada + texto em
 * destaque) era repetido em vários lugares — hoje usado apenas por
 * `CertificadoCalibracaoSection` (Seção 21, anexo escaneado de terceiros que não pode
 * ser gerado dinamicamente). As demais seções institucionais já foram preenchidas com
 * o texto real do modelo aprovado — ver `PdfDocument.js`.
 */
const PlaceholderWarning = ({ title, children }) => (
  <View style={{ border: `1px dashed ${BRADESCO_RED}`, padding: '8px', marginTop: '8px' }}>
    <Text size="xsmall" color={BRADESCO_RED} bold>
      {title}
    </Text>
    <Text size="xsmall" color={BRADESCO_RED}>
      {children}
    </Text>
  </View>
)

export default PlaceholderWarning
